import ReactMDEditor from '@uiw/react-md-editor/nohighlight'

const MarkdownPreview = ReactMDEditor.Markdown

export default MarkdownPreview
